interface Props {
    className: string;
    onClick?: any
}
export default function emfVisualizationIcon({className, onClick}: Props) {
  return (
    <svg onClick={onClick} className={className} id="graph" xmlns="http://www.w3.org/2000/svg" width="30.813" height="16.5" viewBox="0 0 30.813 16.5">
      <g id="Group_194156" data-name="Group 194156" transform="translate(-1735 -524)">
        <path id="path" d="M0,1.96V0L4.406,4.05,8.813,0V1.96L4.406,6Z" transform="translate(1757 529)" fill="currentColor" />
        <g id="Group_194155" data-name="Group 194155" transform="translate(-13 2)">
          <rect id="Rectangle_11717" data-name="Rectangle 11717" width="4" height="22" rx="1" transform="translate(1748 522)" fill="currentColor" />
          <rect id="Rectangle_11718" data-name="Rectangle 11718" width="4" height="16" rx="1" transform="translate(1754 528)" fill="currentColor" opacity="0.75" />
          <rect id="Rectangle_11719" data-name="Rectangle 11719" width="4" height="22" rx="1" transform="translate(1760 522)" fill="currentColor" opacity="0.5" />
          <line id="Line_2676" data-name="Line 2676" x2="15" transform="translate(1748.5 538)" fill="currentColor"/>
        </g>
      </g>
    </svg>
  )
}